import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Wallet } from 'lucide-react';
import * as api from '@/api/cobros.api';

/**
 * «Tienes cobros sin cerrar» — arriba de cualquier pantalla de la vendedora, cuando un pago o una
 * promesa de SUS chats ya recibió un aviso y sigue sin venta confirmada. Se va sola al cerrarlo.
 *
 * ponytail: pregunta cada minuto, igual que el recordatorio de chats esperando.
 */
export function CobrosPorCerrar() {
  const { data } = useQuery({
    queryKey: ['cobros', 'lista', 'ABIERTO', 'franja'],
    queryFn: () => api.listar({ estado: 'ABIERTO' }),
    refetchInterval: 60_000,
    // Un negocio sin ventas responde 404: no hay franja y no se insiste.
    retry: false,
  });
  const avisados = (data ?? []).filter((t) => t.avisos > 0);
  if (avisados.length === 0) return null;
  return (
    <Link
      to="/cobros"
      className="mb-3 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 hover:bg-amber-100 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-200"
    >
      <Wallet className="h-4 w-4 shrink-0" />
      {avisados.length === 1
        ? `${avisados[0]!.cliente}: hay un pago sin venta confirmada. Ciérralo o di qué pasó.`
        : `Tienes ${avisados.length} cobros sin venta confirmada. Ciérralos o di qué pasó.`}
    </Link>
  );
}
